<template>
	<div>
		<ja-modal class="modal-component" :show="show">
			<content class="content">
				<img
					class="page-icon"
					:src="require(`@/assets/images/Jimmy-modal.png`)"
				/>
				<div class="modal-wrapper-content">
					<div class="title-wrapper">
						<h3>{{ $t('warning') }}!</h3>
					</div>
					<div class="text-wrapper">
						<div class="body-text-1">
							{{ $t('noMoneyLeft') }}
						</div>
						<ja-button
							class="small"
							name="forceLifeStageCompletionOk"
							@click.native="completeLifeStage"
						>
							{{ $t('ok') }}
						</ja-button>
					</div>
				</div>
			</content>
		</ja-modal>
	</div>
</template>
<script>
import Modal from './Modal';
import LifeStageData from '../../mixins/LifeStageData';
import gql from 'graphql-tag';
import Button from '../ui/Button';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button
	},
	mixins: [LifeStageData],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		async completeLifeStage() {
			this.$store.commit('setLoading', true);
			const updateData = {
				id: this.lifeStageData.id,
				hideForcedLifeStageCompletionPopup: true,
				isAfterLifeScenarioUnlockedWithPasscode: false,
				isAfterLifeStageSummaryUnlockedWithPasscode: false,
				isAfterSetBudgetUnlockedWithPasscode: false
			};

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentInputObjectGraphType!) {
						updateStudent(update: $update) {
							lifeStage_ID
						}
					}
				`,
				variables: {
					update: updateData
				}
			});

			if (response.data) {
				this.$store.dispatch('getLifeStageData').then(() => {
					this.lifeStageData.hideForcedLifeStageCompletionPopup = true;
					this.$store.commit('setLoading', false);
				});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.modal-component {
	::v-deep .modal {
		max-width: 500px;
		@media (min-width: $breakpoint-mid) {
			max-width: 600px;
		}
	}
}

content {
	position: relative;
	align-items: inherit !important;

	.page-icon {
		max-width: 330px;
		max-height: 250px;
		align-self: center;
		width: 40%;
		margin-top: -80px;
		@media (min-width: $breakpoint-mid) {
			margin-top: -95px;
		}
	}

	h3 {
		margin: 12px 0 12px 0;
	}

	button {
		margin-top: 24px;
	}

	.modal-wrapper-content {
		width: 75%;
		align-self: center;
		margin-bottom: 24px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: initial;

		.title-wrapper {
			text-transform: capitalize;
		}
	}
}
</style>
